import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../public/images/Arrow_reverse.svg'


const _withScopeId = n => (_pushScopeId("data-v-c473f130"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Arrow_reverse"
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "arrow_back",
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goToUrl(_ctx.isProjects)))
  }, [
    _hoisted_1,
    _createElementVNode("p", null, _toDisplayString(_ctx.getStaticLanguage.backPage), 1)
  ]))
}